import { IAccountShippingPreferences } from '../../models/shipping-preferences';
import { LOAD_SHIPPING_PREFERENCES_SUCCESS } from './shipping-preferences-actions';

interface LoadShippingPreferencesSuccess {
    type: 'LOAD_SHIPPING_PREFERENCES_SUCCESS';
    payload: IAccountShippingPreferences[];
}

export const billToShippingPreferencesReducer = (
    state: IAccountShippingPreferences[] = [],
    action: LoadShippingPreferencesSuccess
) => {
    if (action.type === LOAD_SHIPPING_PREFERENCES_SUCCESS) {
        return action.payload;
    }
    return state;
};
